module.exports = __webpack_public_path__ + "bg-1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgs/bg-1.jpg
// module id = 2878
// module chunks = 67